import { Switch as AntSwitch, SwitchProps as AntSwitchProps } from 'antd'

export interface SwitchProps extends AntSwitchProps {
  /**
   * Label text displayed next to the switch
   */
  label?: string
}

/**
 * Switch Component
 *
 * A toggle switch input with optional label.
 *
 * Colors:
 * - ON: #4277BB (blue)
 * - OFF: #BFBFBF (gray)
 * - Disabled: #A8C5E5 with border (light blue outline)
 *
 * @example
 * <Switch label="Enable notifications" />
 *
 * @example
 * // Controlled switch
 * <Switch
 *   checked={isEnabled}
 *   onChange={setIsEnabled}
 *   label="Dark mode"
 * />
 *
 * @example
 * // Switch with custom text
 * <Switch
 *   checkedChildren="ON"
 *   unCheckedChildren="OFF"
 * />
 */
export function Switch({ label, className, disabled, checked, ...props }: SwitchProps) {
  // Build class names for different states
  const switchClasses = [
    'ava-switch',
    disabled ? 'ava-switch-disabled' : '',
    className || '',
  ].filter(Boolean).join(' ')

  const switchElement = (
    <AntSwitch
      {...props}
      checked={checked}
      disabled={disabled}
      className={switchClasses}
    />
  )

  if (label) {
    return (
      <div className="flex items-center gap-2">
        {switchElement}
        <span className="text-sm">{label}</span>
      </div>
    )
  }

  return switchElement
}
